import React, { useState, useCallback } from 'react'
import intl from 'react-intl-universal'
import { useMedia } from '../../hooks'
import { useScroll } from '@raysync/common/hooks'
import { Flex, ShowAtMobile } from '@raysync/common/components'
import { LocaleService } from '@raysync/common/services'
import { LANGUAGE_LIST } from '@raysync/common/config'
import IconLearnMore from '@raysync/common/components/svg/enHome/icon_learnmore'
import {
  Navbar,
  Brand,
  StyledWrapper,
  NavbarWrap,
  LinkWrap,
  IconWrap,
  DropdownWrap,
  DropdownMenu,
  Link,
  ApplyButton,
  DropdownWrapdiv,
  ProductsLS,
  ProductsWrap,
  ProductsLink,
  ProductsLeft,
  ProductsRight,
  ResourcesLeft,
  ResourcesCenter,
  ResourcesRight,
  DropdownWrapRe,
  ResourcesLS,
  ResourcesLink,
  RightLS,
  ProductsText,
  TitleText,
  ProductsIcon,
  overlayStyle,
  Endiv,
  EnWarp,
} from './en-atoms'
import MobileMenu from './en-mobile-menu'
import LogoIcon from '../svg/enHome/logo'
import SubMenuArrow from '../svg/enHome/SubMenuArrow'
import IconProducts1 from '../svg/enHome/icon_products1'
import IconProducts2 from '../svg/enHome/icon_products2'
import IconProducts3 from '../svg/enHome/icon_products3'
import Icon1 from '../svg/enHome/icon_resources1'
import Icon2 from '../svg/enHome/icon_resources2'
import Icon3 from '../svg/enHome/icon_resources3'
import Icon4 from '../svg/enHome/icon_resources4'
import Icon5 from '../svg/enHome/icon_resources5'
import Icon6 from '../svg/enHome/icon_resources6'
import Icon7 from '../svg/enHome/icon_resources7'
import Icon8 from '../svg/enHome/icon_resources8'
import Icon9 from '../svg/enHome/icon_resources9'
import Icon10 from '../svg/enHome/icon_resources10'
import Icon11 from '../svg/enHome/icon_resources11'
import MenuIcon from '../svg/enHome/menu'
import ChackIcon from '../svg/enHome/chack'
import HerderEnIcon from '../svg/enHome/herder-en'
function ScrollHandle({ handler }) {
  useScroll(handler)
  return null
}

const currentPackageName = process.env.GATSBY_PACKAGE_NAME

const Header = ({ location, pageType, isApplyPage, showTopNotice }) => {
  const isMobile = useMedia()
  const [state, setState] = useState({
    isTransparent: false,
    isExpand: false,
    navigationList: [
      {
        text: intl.get('app.header.products'),
        children: [
          {
            link: '/enterprise/',
            text: intl.get('enterprise.link'),
            desc: intl.get('enterprise.desc'),
            icon: 'IconProducts1',
          },
          { link: '/smb/', text: intl.get('app.smb'), desc: intl.get('app.desc'), icon: 'IconProducts2' },
          {
            link: '/raysync-cloud/',
            text: intl.get('cloud.link'),
            desc: intl.get('cloud.desc'),
            icon: 'IconProducts3',
          },
        ],
      },
      {
        link: '/pricing/',
        text: intl.get('app.header.pricing'),
      },
      {
        link: '/casestudies/',
        text: intl.get('app.header.example'),
      },
      {
        text: intl.get('app.header.resources'),
        children: [
          {
            link: '/about-us/',
            text: intl.get('app.header.company.about1'),
            desc: intl.get('app.header.company.about1.desc'),
            icon: 'icon1',
          },
          {
            link: '/support/document/index/',
            text: intl.get('support.help-center'),
            desc: intl.get('support.help-center.desc'),
            icon: 'icon2',
          },
          {
            link: '/support/document/faq/Installation-issues/',
            text: intl.get('app.header.resources.faq'),
            desc: intl.get('app.header.resources.faq.desc'),
            icon: 'icon3',
          },
          {
            link: '/news/',
            text: intl.get('app.footer.entry2'),
            desc: intl.get('app.footer.entry2.desc'),
            icon: 'icon4',
          },
        ],
      },
    ],
    Tools: [
      {
        link: '/partners/',
        text: intl.get('app.header.company.partners'),
        desc: intl.get('app.header.company.partners.desc'),
        icon: 'icon5',
      },
      {
        link: '/calculator/',
        text: intl.get('app.footer.calculator'),
        desc: intl.get('app.footer.calculator.desc'),
        icon: 'icon6',
      },
    ],
    AlternativesList: [
      {
        text: intl.get('app.header.alternatives.title1'),
        link: '/alternatives/aspera-alternative/',
        icon: 'icon7',
      },
      {
        text: intl.get('app.header.alternatives.title2'),
        link: '/alternatives/media-shuttle-alternative/',
        icon: 'icon8',
      },
      {
        text: intl.get('app.header.alternatives.title3'),
        link: '/alternatives/resilio-sync-alternative/',
        icon: 'icon9',
      },
      {
        text: intl.get('app.header.alternatives.title4'),
        link: '/alternatives/masv-alternative/',
        icon: 'icon10',
      },
      {
        text: intl.get('app.header.alternatives.title5'),
        link: '/alternatives/filecatalyst-alternative/',
        icon: 'icon11',
      },
    ],
  })

  const [dropdownStates, setDropdownStates] = useState({})
  const [hoverStates, setHoverStates] = useState({})
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isOverlayVisible, setOverlayVisible] = useState(false)

  const handleScroll = e => {
    setState(prevState => ({
      ...prevState,
      isTransparent: e.target.scrollingElement.scrollTop >= 100,
    }))
  }

  const language = LocaleService.getLocale()

  const toggleExpand = () => {
    setState(prevState => ({ ...prevState, isExpand: !prevState.isExpand }))
  }

  const toggleMenu = () => {
    setIsMenuOpen(prevState => !prevState)
  }

  const handleActive = ({ children, hasMulti }, pathname) => {
    let isActive = false
    if (hasMulti) {
      children.forEach(c => {
        c.items.some(i => new RegExp(`${i.link}$`).test(pathname)) && (isActive = true)
      })
    } else {
      isActive = children.some(i => new RegExp(`${i.link}$`).test(pathname))
    }
    return isActive
  }

  const handleMouseToggle = useCallback((index, isEntering) => {
    setDropdownStates(prevStates => {
      const newState = Object.keys(prevStates).reduce((acc, key) => {
        acc[key] = false
        return acc
      }, {})

      if (index === 0) {
        newState[3] = false
      }
      newState[3] = false
      newState[index] = isEntering ? !prevStates[index] : false
      setOverlayVisible(isEntering)
      return newState
    })
  }, [])

  const { navigationList, isExpand, isTransparent, Tools, AlternativesList } = state
  let pathname = /\/$/.test(location.pathname) ? location.pathname : location.pathname + '/'
  const locale = intl.getInitOptions().currentLocale

  return (
    <React.Fragment>
      {isOverlayVisible && <div style={overlayStyle}></div>}
      <Navbar isTransparent={isTransparent} showTopNotice={showTopNotice}>
        {pageType === 'home' && <ScrollHandle handler={handleScroll} />}
        <StyledWrapper>
          <Brand href={locale === 'en-US' ? '/' : `/${locale.toLowerCase()}`} alt='Raysync' title='Raysync'>
            <LogoIcon />
          </Brand>
          <NavbarWrap halign='space-between' grow={2}>
            <LinkWrap className='hide-at-mobile'>
              {navigationList.map((l, i) =>
                l.children ? (
                  <DropdownMenu
                    key={i}
                    hasMulti={l.hasMulti}
                    isActive={handleActive(l, pathname)}
                    onMouseEnter={() => handleMouseToggle(i, true)}
                    onMouseLeave={() => handleMouseToggle(i, false)}
                  >
                    <Flex alignItems='center' style={{ gap: '8px' }}>
                      <span style={{ fontSize: '16px' }}>{l.text}</span>
                      <div style={{ height: '16px', display: 'flex', alignItems: 'center' }}>
                        <SubMenuArrow isExpand={dropdownStates[i]} />
                      </div>
                    </Flex>
                    <DropdownWrap
                      isOpen={dropdownStates[i]}
                      isResources={l.text === intl.get('app.header.resources')}
                      showTopNotice={showTopNotice}
                    >
                      {l.text === intl.get('app.header.products') && (
                        <DropdownWrapdiv>
                          {l.children.map((k, j) => (
                            <ProductsLS isActive={new RegExp(`${k.link}$`).test(pathname)} key={j + 100}>
                              <ProductsWrap>
                                <ProductsLeft>
                                  {k.icon === 'IconProducts1' && <IconProducts1 />}
                                  {k.icon === 'IconProducts2' && <IconProducts2 />}
                                  {k.icon === 'IconProducts3' && <IconProducts3 />}
                                </ProductsLeft>
                                <ProductsRight>
                                  <ProductsLink
                                    style={{ fontSize: 14 }}
                                    to={k.link}
                                    isInternal={currentPackageName === 'main'}
                                    isActive={new RegExp(`${k.link}$`).test(pathname)}
                                    onMouseEnter={() => setHoverStates(prev => ({ ...prev, [k.link]: true }))}
                                    onMouseLeave={() => setHoverStates(prev => ({ ...prev, [k.link]: false }))}
                                  >
                                    <ProductsText>
                                      <TitleText>{k.text}</TitleText>
                                      <IconLearnMore fill={hoverStates[k.link] ? '#FD5C1F' : 'white'} />
                                    </ProductsText>
                                    <p>{k.desc}</p>
                                  </ProductsLink>
                                </ProductsRight>
                              </ProductsWrap>
                            </ProductsLS>
                          ))}
                        </DropdownWrapdiv>
                      )}
                      {l.text === intl.get('app.header.resources') && (
                        <DropdownWrapRe>
                          <ResourcesLeft>
                            <p>{intl.get('app.header.products.title1')}</p>
                            {l.children.map((k, j) => (
                              <ResourcesLS isActive={new RegExp(`${k.link}$`).test(pathname)} key={j + 100}>
                                <ProductsWrap>
                                  <ProductsIcon>
                                    {k.icon === 'icon1' && <Icon1 />}
                                    {k.icon === 'icon2' && <Icon2 />}
                                    {k.icon === 'icon3' && <Icon3 />}
                                    {k.icon === 'icon4' && <Icon4 />}
                                  </ProductsIcon>
                                  <ProductsRight>
                                    <ResourcesLink
                                      style={{ fontSize: 14 }}
                                      to={k.link}
                                      isInternal={currentPackageName === 'main'}
                                      isActive={new RegExp(`${k.link}$`).test(pathname)}
                                      onMouseEnter={() => setHoverStates(prev => ({ ...prev, [k.link]: true }))}
                                      onMouseLeave={() => setHoverStates(prev => ({ ...prev, [k.link]: false }))}
                                    >
                                      <ProductsText>
                                        <TitleText>{k.text}</TitleText>
                                        <IconLearnMore fill={hoverStates[k.link] ? '#FD5C1F' : 'white'} />
                                      </ProductsText>
                                      <p>{k.desc}</p>
                                    </ResourcesLink>
                                  </ProductsRight>
                                </ProductsWrap>
                              </ResourcesLS>
                            ))}
                          </ResourcesLeft>

                          <ResourcesCenter>
                            <p>{intl.get('app.header.products.title2')}</p>
                            {Tools.map((k, i) => (
                              <ResourcesLS isActive={new RegExp(`${k.link}$`).test(pathname)} key={i + 100}>
                                <ProductsWrap>
                                  <ProductsIcon>
                                    {k.icon === 'icon5' && <Icon5 />}
                                    {k.icon === 'icon6' && <Icon6 />}
                                  </ProductsIcon>
                                  <ProductsRight>
                                    <ResourcesLink
                                      style={{ fontSize: 14 }}
                                      to={k.link}
                                      isInternal={currentPackageName === 'main'}
                                      isActive={new RegExp(`${k.link}$`).test(pathname)}
                                      onMouseEnter={() => setHoverStates(prev => ({ ...prev, [k.link]: true }))}
                                      onMouseLeave={() => setHoverStates(prev => ({ ...prev, [k.link]: false }))}
                                    >
                                      <ProductsText>
                                        <TitleText>{k.text}</TitleText>
                                        <IconLearnMore fill={hoverStates[k.link] ? '#FD5C1F' : 'white'} />
                                      </ProductsText>
                                      <p>{k.desc}</p>
                                    </ResourcesLink>
                                  </ProductsRight>
                                </ProductsWrap>
                              </ResourcesLS>
                            ))}
                          </ResourcesCenter>

                          <ResourcesRight>
                            <p>{intl.get('app.header.products.title3')}</p>
                            {AlternativesList.map((k, i) => (
                              <RightLS isActive={new RegExp(`${k.link}$`).test(pathname)} key={i + 100}>
                                <ProductsIcon>
                                  {k.icon === 'icon7' && <Icon7 />}
                                  {k.icon === 'icon8' && <Icon8 />}
                                  {k.icon === 'icon9' && <Icon9 />}
                                  {k.icon === 'icon10' && <Icon10 />}
                                  {k.icon === 'icon11' && <Icon11 />}
                                </ProductsIcon>
                                <ProductsRight>
                                  <ResourcesLink
                                    style={{ fontSize: 14 }}
                                    to={k.link}
                                    isInternal={currentPackageName === 'main'}
                                    isActive={new RegExp(`${k.link}$`).test(pathname)}
                                    onMouseEnter={() => setHoverStates(prev => ({ ...prev, [k.link]: true }))}
                                    onMouseLeave={() => setHoverStates(prev => ({ ...prev, [k.link]: false }))}
                                  >
                                    <ProductsText>
                                      <TitleText>{k.text}</TitleText>
                                      <IconLearnMore fill={hoverStates[k.link] ? '#FD5C1F' : 'white'} />
                                    </ProductsText>
                                  </ResourcesLink>
                                </ProductsRight>
                              </RightLS>
                            ))}
                          </ResourcesRight>
                        </DropdownWrapRe>
                      )}
                    </DropdownWrap>
                  </DropdownMenu>
                ) : l.packageName ? (
                  <Link
                    key={i}
                    to={l.link}
                    style={{ fontSize: '16px' }}
                    isInternal={currentPackageName === l.packageName}
                    isActive={pathname.split('/').includes(l.packageName)}
                  >
                    {l.text}
                  </Link>
                ) : (
                  <Link
                    key={i}
                    to={l.link}
                    style={{ fontSize: '16px', paddingTop: '0' }}
                    isInternal={currentPackageName === 'main'}
                    isActive={l.link === '/' ? /^(\/es)?\/$/.test(pathname) : new RegExp(`${l.link}$`).test(pathname)}
                  >
                    {l.text}
                  </Link>
                ),
              )}
            </LinkWrap>
            {!isApplyPage ? (
              <Flex>
                {!isMobile && (
                  <Endiv onClick={toggleMenu}>
                    <HerderEnIcon />
                    <span>{LocaleService.getLanguageCode(language)}</span>
                    <SubMenuArrow isExpand={isMenuOpen} />
                    <EnWarp style={{ display: isMenuOpen ? 'block' : 'none' }}>
                      {LANGUAGE_LIST.map(({ locale, path, label }) => (
                        <div key={locale} style={{ display: 'flex', alignItems: 'center' }}>
                          {language === locale && <ChackIcon />}
                          <a
                            onClick={() => {
                              LocaleService.changeLocale(locale)
                            }}
                            style={{
                              color: language === locale ? '#FD5C1F' : '#333333',
                              marginLeft: language === locale ? '8px' : '0',
                            }}
                          >
                            {label}
                          </a>
                        </div>
                      ))}
                    </EnWarp>
                  </Endiv>
                )}
                <Link to='/apply' id='FreeTrial'>
                  <ApplyButton>{intl.get('app.header.en.apply')}</ApplyButton>
                </Link>
              </Flex>
            ) : null}
          </NavbarWrap>
          <IconWrap onClick={toggleExpand}>
            <MenuIcon />
          </IconWrap>
        </StyledWrapper>
        <ShowAtMobile>
          <MobileMenu
            isExpand={isExpand}
            closeExpand={toggleExpand}
            list={navigationList}
            pathname={pathname}
            showTopNotice={showTopNotice}
          ></MobileMenu>
        </ShowAtMobile>
      </Navbar>
    </React.Fragment>
  )
}

export default Header
